module.exports = __webpack_public_path__ + "img/DK_DKSword.7acabaa2.png";